<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .education-item {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;

    .header-row {
      display: flex;
      gap: utils.in_rem(8px);
      align-items: flex-start;

      .school {
        @include mixins.h5;
        @include colors.color(primary_90);
        overflow-wrap: break-word;
        word-wrap: break-word;
      }

      .duration {
        @include mixins.body3;
        @include colors.color(black_50);
        overflow-wrap: break-word;
        word-wrap: break-word;
      }
    }

    .degree-field {
      @include mixins.body3;
      @include colors.color(black_90);
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
  }
</style>

<script>
  import { formatDate } from "./utils.js";

  let { education } = $props();

  let startDate = $derived(formatDate(education.startedAt));
  let endDate = $derived(formatDate(education.endedAt, "Present"));
  let duration = $derived(
    startDate && endDate ? `${startDate} - ${endDate}` : ""
  );
</script>

<div class="education-item">
  {#if education.school || duration}
    <div class="header-row">
      {#if education.school}
        <div class="school">{education.school}</div>
      {/if}
      {#if duration}
        <div class="duration">{duration}</div>
      {/if}
    </div>
  {/if}
  {#if education.degree || education.field}
    <div class="degree-field">
      {#if education.degree && education.field}
        {education.degree}, {education.field}
      {:else if education.degree}
        {education.degree}
      {:else if education.field}
        {education.field}
      {/if}
    </div>
  {/if}
</div>
